import React, { Component } from "react";
import Tippy from "@tippyjs/react";
import 'tippy.js/dist/tippy.css';

class BoatInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allureTooltip: ''
        }

    }
    render() {
        const boat = this.props.boatData;

        if (boat) {
            let adjustedWindDirection = boat.weather.wind.deg;

            if (adjustedWindDirection > 180) adjustedWindDirection -= 180;
            else adjustedWindDirection += 180;

            let allureName;
            if (this.props.bearingIsChanging) allureName = <i>{this.getAllureName(this.getCleanedAngle(this.props.desiredBearing), adjustedWindDirection)}</i>
            else allureName = this.getAllureName(boat.bearing, adjustedWindDirection)

            return (
                <div id="boat_info">
                    <span id="boat_bearing">{boat.bearing} °</span>
                    <span id="boat_speed">{(boat.speed.toFixed(1))}<span className="unit">km/h</span></span>
                    <Tippy content={(
                        <div>
                            <b>Vent arrière</b> le vent provient de l'arrière du voilier<br />
                            <b>Grand largue</b > le vent provient de 3/4 arrière du voilier < br />
                            <i>Largue</i><br />
                            <b>Travers</b> le vent provient du côté du voilier < br />
                            <i>Petit largue</i><br />
                            <b>Bon plein</b> le vent provient de 3/4 avant du voilier < br />
                            <b>Vent debout</b> le vent provient de l'avant du voilier
                        </div>
                    )} allowHTML='true' theme='custom' placement='auto'>
                        <span id="boat_allure">{allureName}</span>
                    </Tippy>


                </div>

            );
        } else {
            return <div></div>
        }
    }

    getAllureName(bearing, windDirection) {

        let allure = windDirection - bearing;

        if (allure < -180) allure += 360;
        else if (allure > 180) allure -= 360;
        allure = Math.abs(allure);

        let allureName;
        if (allure < 23) {
            allureName = 'Vent arrière';
        } else if (allure < 65) {
            allureName = 'Grand largue';
        } else if (allure < 85) {
            allureName = 'Largue';
        } else if (allure < 95) {
            allureName = 'Travers';
        } else if (allure < 115) {
            allureName = 'Petit largue';
        } else if (allure < 135) {
            allureName = 'Bon plein';
        } else if (allure < 142) {
            allureName = 'Près';
        } else {
            allureName = 'Vent debout';
        }

        return allureName;
    }

    getCleanedAngle(angle) {
        let angleValue = angle - 90;
        if (angleValue < 0) {
            angleValue += 360;
        }
        return 360 - angleValue;
    }
}


export default BoatInfo;
